import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { randomId } from 'server/shared/helpers/random';
import { SexEnum } from 'server/shared/models/sex.enum';
import { ToastService } from '../../services/toast/toast.service';
@Component({
  selector: 'register-form',
  templateUrl: 'register.component.html',
  styleUrls: ['register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
  return?: string;
  stepperPage: number = 1;

  visibleStep: number = 1; //may vary with different register methods

  isThirdPartySignUp: boolean = false;
  isLoggedOut: boolean = true;

  sexEnum = SexEnum;
  email: string = '';
  randomId: string = randomId();

  showLoadingIndicator: boolean = false;

  private loggedOutTracker?: Tracker.Computation;

  constructor(
    private router: Router,
    private toastService: ToastService,
    private ngZone: NgZone,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.loggedOutTracker = Tracker.autorun(() => {
      this.ngZone.run(() => {
        this.isLoggedOut = !Meteor.userId();
      });
    });
    this.onProviderEmailClick();
  }

  ngOnDestroy() {
    if (this.loggedOutTracker) {
      this.loggedOutTracker.stop();
    }
  }

  private _setThirdPartySetup() {
    this.isThirdPartySignUp = true;
    this.router.navigate(['/welcome']).then();
  }

  onProviderEmailClick() {
    this.stepperPage = 2;
    this.visibleStep = 1;
  }

  registerWithEmail() {
    this.ngZone.run(() => {
      this.showLoadingIndicator = true;
    });
    Meteor.call(
      'registerUserWithEmail',
      this.email,
      this.randomId,
      (error: Meteor.Error) => {
        if (error) {
          this.ngZone.run(() => {
            this.showLoadingIndicator = false;
          });
          if (error.error == 'EmailOccupied') {
            this.toastService.add({
              type: 'ERROR',
              message: 'optInEmailExists',
            });
          } else if (error.error == 'ExistingUserInSetup') {
            this.randomId = error.reason?.toString() || '';
            this.ngZone.run(() => {
              this.router.navigate(['/welcome']).then();
            });
            this.login();
          } else {
            console.log(error);
            this.toastService.add({ type: 'ERROR', message: 'serverError' });
          }
        } else {
          this.ngZone.run(() => {
            this.router.navigate(['/welcome']).then();
          });
          this.login();
        }
      },
    );
  }

  login() {
    // @ts-ignore
    Accounts.callLoginMethod({
      methodArguments: [
        {
          user: { email: this.email },
          password: this.randomId,
        },
      ],
    });
  }
}
